<div class="registrationPaymentDiv">
  <odq-summary [model]="model"
    [loading]="loading"
    [inactiveMemberForSubscription]="inactiveMemberForSubscription"
    [selectedPremium] = "selectedPremium">
  </odq-summary>
  @if (selectedPremium?.total>0) {
    <div class="paymentDiv">
      <mat-card appearance="outlined">
        <mat-card-header>
          {{ 'shoppingCart.checkout.title' | translate }}
        </mat-card-header>
        <mat-card-content>
          <div class="row paymentContent">
            @if (selectedPremium?.total) {
              <div class="d-flex">
                <div class="d-flex flex-column">
                  <!-- CREDIT CARD INPUTS -->
                  <span>
                    {{'subscription.form.payment.amountToPayBefore' | translate}}
                    <span class="bold">{{selectedPremium?.total | currencyCustom}} </span>
                    {{'subscription.form.payment.amountToPayAfter' | translate}}
                  </span>
                  @if (!hidePayment) {
                    <odq-payment [monerisStoreId]="storeId"
                    (dataKeyCreated)="doPayment($event)"></odq-payment>
                    <!-- NAME UNDER CARD -->
                    @if (!isCreditCardProcessing) {
                      <div id="name-under-card"
                        >
                        <label for="nameUnderCard">{{'subscription.form.payment.nameUnderCard' | translate}}</label>
                        <input type="text"
                          [(ngModel)]="nameUnderCard"
                          required
                          name="nameUnderCard">
                        </div>
                      }
                    }
                    <br/>
                    <!-- PAYMENT ERRORS -->
                    @if (!!(paymentError$ | async) && hidePayment) {
                      <div
                        class="paymentError d-flex flex-column" style="gap: 8px">
                        <h4>{{paymentError$ | async}}</h4>
                        @if (canRetry) {
                          <div class="retryDiv">
                            <span>{{'subscription.form.payment.reassuranceMessage' | translate}}</span>
                            <!-- RETRY BUTTON -->
                            <button mat-raised-button
                              (click)="retryPayment()">
                              {{'navigation.retry' | translate}}
                            </button>
                          </div>
                        }
                      </div>
                    }
                    <!-- PAY BY CHEQUE -->
                    @if (model.isPaymentByCheckedAllowed) {
                      <button mat-raised-button
                        id="paymentParCheck"
                        color="primary"
                        [disabled]="isCreditCardProcessing"
                        (click)="payByCheck()">
                        {{ 'subscription.form.payment.checkPayment' |translate}}
                      </button>
                    }
                  </div>
                </div>
              } @else {
                <p class="font-weight-bold text-danger">{{'subscription.form.payment.billError' | translate}}</p>
              }
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    }
    <!-- PAYMENT PROCESSING LOADER-->
    @if (isCreditCardProcessing) {
      <div
        class="spinner-container">
        <mat-spinner [diameter]="10"></mat-spinner>
      </div>
    }
  </div>

  <ng-template #loadingTemplate>
    <div class="row loader">
      <div class="spinner-container">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  </ng-template>

